export function Search2(): React.JSX.Element {
  return (
    <svg
      fill="none"
      height="fill"
      viewBox="0 0 37 37"
      width="fill"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6431 17.853H24.3214"
        stroke="#929292"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.81683"
      />
      <path
        d="M17.8521 24.3216V11.3845"
        stroke="#929292"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.81683"
      />
      <path
        d="M17.7288 32.3749C25.8175 32.3749 32.3747 25.8178 32.3747 17.7291C32.3747 9.64041 25.8175 3.08325 17.7288 3.08325C9.64017 3.08325 3.08301 9.64041 3.08301 17.7291C3.08301 25.8178 9.64017 32.3749 17.7288 32.3749Z"
        stroke="#FF7700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.81683"
      />
      <path
        d="M33.9163 33.9168L30.833 30.8335"
        stroke="#FF7700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.81683"
      />
    </svg>
  );
}
